/* unplugin-vue-components disabled */import script from "./serviceArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./serviceArea.vue?vue&type=script&setup=true&lang=ts"

import "./serviceArea.vue?vue&type=style&index=0&id=1479d4e3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1479d4e3"]])

export default __exports__